export var DefaultSpacing = {
    s2: '4px',
    s1: '8px',
    m: '16px',
    l1: '20px',
    l2: '32px'
};
//# sourceMappingURL=DefaultSpacing.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/node_modules/@uifabric/styling/lib/styles/DefaultSpacing.js
// module id = 589
// module chunks = 0